import {SystemSecondaryCustomButton} from "../../buttons/SystemCustomButton";
import {kButtonStyles} from "../../../constants/styles";
import {kInternalRoutes} from "../../../constants/internalRoutes";
import HomeMissionTexts from "../../texts/homeScreen/HomeMissionTexts";
import HomeMissionVideo from "../../videos/homeScreen/HomeMissionVideo";

export default function HomeMission() {
    // Used in HomScreen to display section related to Ummia mission
    // made of title, subtitle and video

    // BUILD
    return (
        <div className={"bg-backgroundLight3 w-full flex flex-col justify-center items-center py-[96px]"}>
            <div className={"w-full max-w-[1200px] flex flex-col md:flex-row md:items-start space-x-[0px] space-y-[32px] md:space-x-[32px] md:space-y-[6px] lg:space-x-[48px] px-[32px] lg:px-[48px]"}>
                <div className={"grow min-w-[304px] max-w-[480px] h-[228px] min-h-[228px] flex flex-col justify-between items-start"}>
                    <HomeMissionTexts />
                    <SystemSecondaryCustomButton
                        label={"En savoir plus"}
                        isDisabled={false}
                        isLoading={false}
                        isFullWidth={false}
                        sizeStyle={kButtonStyles.largeButtonStyle}
                        externalLink={kInternalRoutes.about} extraClass={'mt-[16px]'}/>
                </div>
                <HomeMissionVideo />
            </div>
        </div>
    );
}